let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("253I8")).then(() => parcelRequire('2y4Ff'));